<app-tdo-subnav data-cy="tdo-smartnav">
  @if (isReady) {
    @for (item of navbarItems; track $index) {
      <app-tdo-subnav-item [model]="item" [name]="item?.label" (mouseenter)="isShowMenu = false;" (click)="onItemClicked(item)" (selected)="onSubnavItemSelected($event)" data-cy="tdo-smartnav-item-{{item?.label}}">{{item?.label}}</app-tdo-subnav-item>
    }
  }
  @if (isReady) {
    <div class="tdo-dropdown-menu" (mouseover)="isShowMenu = true" (appClickOutside)="isShowMenu = false" data-cy="tdo-smartnav-dropdown-menu">
      <lucide-icon name="menu" [size]="20" style="color: var(--color-navy); margin-top: 6px; margin-right: 8px; cursor: pointer;" (click)="onMenuClick()" data-cy="tdo-smartnav-menu-icon"></lucide-icon>
      <div class="tdo-dropdown-menu-content" [ngClass]="{'tdo-dropdown-menu-show': isShowMenu}" style="overflow-x: visible; width: 120px;" data-cy="tdo-smartnav-dropdown-content">
        @for (item of hamburgerItems; track $index) {
          <div class="tdo-dropdown-menu-item" (click)="onItemClicked(item)" (mouseenter)="onHamburgerItemMouseEnter($event, item)" (mouseleave)="onHamburgerItemLeave($event, item)" style="position: relative;" data-cy="tdo-smartnav-hamburger-item-{{item.label}}">
            <div style="display: flex; height: fit-content;" data-cy="tdo-smartnav-hamburger-item-content">
              @if (item?.children.length > 0) {
                <div style="position: relative; top: -3px; left: -3px; height: 20px; width: 14px; overflow: hidden;" data-cy="tdo-smartnav-hamburger-chevron"><lucide-icon name="chevron-left" [size]="20" style="position: relative; left: -4px;"></lucide-icon></div>
              }
              <div style="flex: 1;" data-cy="tdo-smartnav-hamburger-label">{{item.label}}</div>
            </div>
            @if (item?.children.length > 0) {
              <div class="tdo-dropdown-menu" style="position: absolute;" data-cy="tdo-smartnav-submenu">
                <div class="tdo-dropdown-menu-content" style="top: -20px; right: 6px; border: 2px solid var(--tdo-primary-accent);" [ngClass]="{'tdo-dropdown-menu-show': item.isShowMenu}" data-cy="tdo-smartnav-submenu-content">
                  @for (subitem of item?.children; track $index) {
                    <div class="tdo-dropdown-menu-item" (click)="handleHamburgerSelection(subitem)" data-cy="tdo-smartnav-submenu-item-{{subitem.label}}">
                      {{subitem.label}}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</app-tdo-subnav>
